import { FONT_BASE, FONT_MAX, LINE_HEIGHT_BASE } from '../themeConstants'

export const typographyBody = {
  subtitle1: {
    fontSize: FONT_MAX,
    lineHeight: LINE_HEIGHT_BASE,
    fontWeight: 600,
  },
  subtitle2: {
    fontSize: FONT_MAX,
    lineHeight: LINE_HEIGHT_BASE,
    fontWeight: 500,
  },
  body1: {
    fontSize: FONT_BASE,
    lineHeight: LINE_HEIGHT_BASE,
  },
  body2: {
    fontSize: FONT_BASE,
    lineHeight: LINE_HEIGHT_BASE,
  },
  caption: {
    fontSize: FONT_BASE,
    lineHeight: LINE_HEIGHT_BASE,
  },
  button: {
    fontSize: FONT_BASE,
    lineHeight: LINE_HEIGHT_BASE,
    fontWeight: 590,
    textTransform: 'none',
  },
  overline: {
    fontSize: FONT_BASE,
    lineHeight: LINE_HEIGHT_BASE,
    fontWeight: 400,
    textTransform: 'none',
    letterSpacing: 'normal',
  },
}
